// @flow
import React from 'react';
import {Alert} from '@mui/material';
import {Widget, WidgetTitle} from "../../Common";
import {JsonAnimal} from "../../../api/generated/rest-dto";
import {useHistory} from "react-router-dom";
import Pedigree from "../../Pedigree/pedigree";
import RouteService from "../../../services/route-service";
import EditIcon from "@mui/icons-material/Edit";
import {AltRoute} from "@mui/icons-material";

type PedigreeWidgetProps = {
    animal: JsonAnimal
    isRegistered: boolean
    isRegistryWarden?: boolean
    expandedRedirectUrl?: string
};

const PedigreeWidget: React.FC<PedigreeWidgetProps> = ({animal, isRegistered, isRegistryWarden = false, expandedRedirectUrl}) => {
    const history = useHistory();

    const editAncestryAction = () => history.push({
            pathname: RouteService.expand(RouteService.ANIMAL_CHANGE_ANCESTRY, {panonId: animal.panonIdentifier.id})
        },
        {expandedRedirectUrl});
    const cardMenuEntries = isRegistryWarden ? [] : [{
        actionName: "Stammbaum bearbeiten",
        actionFunction: editAncestryAction
    }];
    const quickActions = isRegistryWarden ? [] : [{
        icon: <EditIcon/>,
        action: editAncestryAction,
    }];
    return (
        <Widget displayName={
            <WidgetTitle startIcon={<AltRoute color="success" />}>
                Stammbaum
            </WidgetTitle>
        }
                editable={!isRegistered || isRegistryWarden}
                cardMenuEntries={cardMenuEntries}
                quickActions={quickActions}>
            {isRegistered ? (<Alert sx={{marginBottom: 1}} severity="info">Dieser Stammbaum wird durch das Register verwaltet</Alert>) : null}
            <Pedigree animal={animal} editable={isRegistryWarden} expandedRedirectUrl={expandedRedirectUrl}/>
        </Widget>
    );
};

export default PedigreeWidget
